import styled from '@emotion/styled';

import Logo from '~/components/Logo';

const HeaderWrapper = styled.header`
  background-color: var(--color-bg-surface);
  border-bottom: 1px solid var(--color-border);
  height: 64px;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 200;
`;

const Inner = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: space-between;
  margin: 0 auto;
  max-width: var(--max-width-app);
  padding: 0 var(--space-lg);
`;

const NavLinks = styled.nav`
  align-items: center;
  display: flex;
  gap: var(--space-md);
`;

const NavLink = styled.a`
  color: var(--color-text-secondary);
  font-family: var(--font-ui);
  font-size: var(--font-size-label);
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--letter-spacing-label);
  text-transform: uppercase;
  transition: color var(--transition-base);

  &:hover {
    color: var(--color-accent);
  }
`;

export default function Header() {
  return (
    <HeaderWrapper data-component-name="Header">
      <Inner>
        <Logo />
        <NavLinks>
          <NavLink href="https://github.com" rel="noopener noreferrer" target="_blank">
            GitHub
          </NavLink>
        </NavLinks>
      </Inner>
    </HeaderWrapper>
  );
}
